import UIFacade from "../../UIFacade";
import LocalizedPIXIText from "@localisation/LocalizedPIXIText";
import ConfigDynamicTextStylesBase from "../../config/ConfigDynamicTextStylesBase";
import SimpleTextComponent from "@baseUI/component/text/SimpleTextComponent";

export default class DynamicTextComponent extends SimpleTextComponent {

  constructor(name, key, style) {
    super(style)
    this.name = name
    // Signals.setValue.add(this.onSetValue, this)
    // Signals.dynamicTextValueChanged.add(this.onDynamicTextValueChanged, this)
    this.init()
  }

  init() {
    if(ConfigDynamicTextStylesBase.dynamicText[this.name]) {
      let style = this.styled ? this.styled : UIFacade.textFactory.getStyle(ConfigDynamicTextStylesBase.dynamicText[this.name].styleName)
      this.localizedPIXIText = new LocalizedPIXIText('', style)
      if(this.localizedPIXIText.style.align === "center") {
        this.localizedPIXIText.anchor.set(0.5)
      } else {
        this.localizedPIXIText.anchor.set(0, 0.5)
      }
      this.addChild(this.localizedPIXIText)
    } else {
      console.log('ERROR: Dynamic text not found with name:', this.name)
    }
    this.localizedPIXIText.text = '000000'
  }

  update(value) {
      this.localizedPIXIText.text = value
  }

  // onDynamicTextValueChanged(key, value) {
  //   if (key == this.key) {
  //     this.localizedPIXIText.text = value
  //   }
  // }



  
}